import React from "react";
import Types from "prop-types";
import { withTranslation } from "react-i18next";
import Galileo from "../../galileo";

export class PasswordField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      listOfWeakPasswords: [],
      validationError: null,
    };
  }

  componentDidMount() {
    if (this.props.validateWeakPassword) {
      Galileo.fetchWeakPasswords().then((_list) => {
        if (_list) {
          this.setState({ listOfWeakPasswords: _list.split(",") });
        }
      });
    }
  }

  onToggleChange({ target }) {
    this.setState({ showPassword: target.checked });
  }

  onChange(event) {
    const { onChange, validateWeakPassword, onValidityChange, minLength } = this.props;

    if (onChange) onChange(event);

    if (!validateWeakPassword) return;

    const value = event.target.value;
    const min = minLength || 6;
    let validationError = null;
    let isInvalid = false;

    if (value.length > 0 && value.length < min) {
      isInvalid = true;
      validationError = `Please lengthen your password to ${min} characters or more (you are currently using ${value.length} characters)`;
    } else if (
      value &&
      this.state.listOfWeakPasswords?.some(
        (p) => p.toLowerCase() === value.toLowerCase()
      )
    ) {
      isInvalid = true;
      validationError = "Your password is easily guessed. Please try a stronger password.";
    }

    this.setState({ validationError });
    if (onValidityChange) onValidityChange(isInvalid);
  }

  renderToggle(id) {
    const { t, showToggle } = this.props;
    if (showToggle === false) return null;
    return (
      <label className="reset-password-label" htmlFor={`${id}-show-toggle`}>
        <input
          type="checkbox"
          id={`${id}-show-toggle`}
          onChange={this.onToggleChange.bind(this)}
        />
        <span>&nbsp;{t("reset_password:show_password")}</span>
      </label>
    );
  }

  renderClassic() {
    const {
      id,
      name,
      value,
      label,
      placeholder,
      required,
      autoFocus,
      autoComplete,
      onFocus,
      minLength,
    } = this.props;
    const { showPassword, validationError } = this.state;

    return (
      <>
        <div className="material-form-field">
          <input
            type={showPassword ? "text" : "password"}
            autoComplete={autoComplete}
            spellCheck="false"
            id={id}
            name={name}
            onChange={this.onChange.bind(this)}
            onFocus={onFocus}
            value={value}
            placeholder={placeholder}
            required={required}
            autoFocus={autoFocus}
            minLength={minLength}
          />
          <label className="material-form-field-label" htmlFor={id}>
            {label}
          </label>
        </div>
        {validationError && <div className="invalid show">{validationError}</div>}
        {this.renderToggle(id)}
      </>
    );
  }

  renderEnhanced() {
    const {
      id,
      name,
      value,
      label,
      placeholder,
      required,
      autoFocus,
      autoComplete,
      onFocus,
      minLength,
      hasError,
    } = this.props;
    const { showPassword, validationError } = this.state;

    return (
      <>
        <label
          className="express-form-field-label show express-common"
          htmlFor={id}
        >
          {label}
        </label>
        <div className={`express-form-field express-common${hasError ? " show" : ""}`}>
          <input
            type={showPassword ? "text" : "password"}
            autoComplete={autoComplete}
            spellCheck="false"
            id={id}
            name={name}
            onChange={this.onChange.bind(this)}
            onFocus={onFocus}
            value={value}
            placeholder={placeholder}
            required={required}
            autoFocus={autoFocus}
            minLength={minLength}
          />
        </div>
        {validationError && <div className="invalid show">{validationError}</div>}
        {this.renderToggle(id)}
      </>
    );
  }

  render() {
    const { variant } = this.props;
    return variant === "enhanced" ? this.renderEnhanced() : this.renderClassic();
  }
}

PasswordField.propTypes = {
  t: Types.func.isRequired,
  id: Types.string.isRequired,
  name: Types.string.isRequired,
  label: Types.string.isRequired,
  onChange: Types.func.isRequired,
  value: Types.string,
  placeholder: Types.string,
  required: Types.bool,
  minLength: Types.number,
  autoFocus: Types.bool,
  autoComplete: Types.string,
  onFocus: Types.func,
  variant: Types.oneOf(["classic", "enhanced"]),
  showToggle: Types.bool,
  validateWeakPassword: Types.bool,
  onValidityChange: Types.func,
  hasError: Types.bool,
};

PasswordField.defaultProps = {
  autoComplete: "off",
  variant: "classic",
  showToggle: true,
  validateWeakPassword: false,
  hasError: false,
};

export default withTranslation()(PasswordField);
